
import Login from "../components/login";


function Loginpage() {
  return (
    <div>
    <div className='wrapper'>
     <Login/>
    </div>
  
  </div>

  );
}
export default Loginpage;
